import { useState } from 'react'

import { readThemePreference, saveThemePreference } from '@/lib/theme'
import type { ThemePreference } from '@/lib/theme'

export function useTheme() {
  const [preference, setPreference] = useState<ThemePreference>(readThemePreference)
  const update = (next: ThemePreference) => {
    saveThemePreference(next)
    setPreference(next)
  }
  return { preference, setPreference: update }
}
